<template lang="html">
  <div>
    <b-row>
      <b-col sm="12" style="margin-bottom:20px;">
        <div class="input-bottom-line">
          <b-row>
            <b-col sm="7">
              <b-row>
                <b-col sm="3" class="wise-small-header wise-small-header2" style="margin-right:-20px;">모델명</b-col>
                <b-col sm="9" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.vehicle}}</b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="3" class="wise-small-header wise-small-header2">생성일</b-col>
                <b-col sm="9" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.std_dt}}</b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="input-bottom-line">
          <b-row>
            <b-col sm="3">
              <b-row>
                <b-col sm="6" class="wise-small-header wise-small-header2">광고소재</b-col>
                <b-col sm="6" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.media_type}}</b-col>
              </b-row>
            </b-col>
            <b-col sm="2">
              <b-row>
                <b-col sm="6" class="wise-small-header wise-small-header2">미디어</b-col>
                <b-col sm="6" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.media}}</b-col>
              </b-row>
            </b-col>
            <b-col sm="2">
              <b-row>
                <b-col sm="6" class="wise-small-header wise-small-header2">채널</b-col>
                <b-col sm="6" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.channel}}</b-col>
              </b-row>
            </b-col>
            <!-- <b-col sm="2">
              <b-row>
                <b-col sm="6" class="wise-small-header wise-small-header2">타겟</b-col>
                <b-col sm="6" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.target}}</b-col>
              </b-row>
            </b-col> -->
            <b-col sm="2">
              <b-row>
                <b-col sm="6" class="wise-small-header wise-small-header2">리미트</b-col>
                <b-col sm="6" class="form-control no-border" style="padding-left:0px;font-weight:900;">{{myModel.lmt}}</b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="12" style="margin-bottom:20px;">
        <div id="customModelChart1234" class="CSSAnimationChart"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import modelModalChart from "./modelModalChart.js";

export default {
  props: {
    model:{
      media_type:'',
      media:'',
      channel:'',
      target:'',
      vehicle:'',
      std_dt:'null',
      lmt:0,
      a:0,
      b1:0,
      b2:0,
      b3:0
    },
  },
  data(){
    return {
      rowDataArr:[],
      myModel:{
        media_type:'',
        media:'',
        channel:'',
        target:'',
        vehicle:'',
        std_dt:'null',
        lmt:0,
        a:0,
        b1:0,
        b2:0,
        b3:0
      },
    }
  },
  mounted: function() {
    // this.makeResult();
    // this.makeResult();
  },
  watch: {
    'model' : function(){
      this.myModel = this.model;
      this.makeResult();
    }
  },
  methods:{
    makeResult(){
      this.rowDataArr = [];
      for(var i=0; i<3000; i++){
        var lowData = {};
        lowData.grps = i;
        lowData.reach1 = this.inputLevelCalc(this.model, i);
        this.rowDataArr.push(lowData);
      }
      modelModalChart.drawChart(this.rowDataArr);
      // console.log(this.rowDataArr);
    },
    inputLevelCalc(cffcnt, grps){ // 공통파일로 대체 필요
      var z = (
        cffcnt.a +
        cffcnt.b1 * Math.log(grps) +
        cffcnt.b2 * Math.pow(Math.log(grps),2) +
        cffcnt.b3 * Math.pow(Math.log(grps),3)
      );
      var z2 = 1 + Math.exp(-z);
      var result = (cffcnt.lmt/z2) * 100;
      if(isNaN(result)){ // 여기에 넣기에는 너무 부담스럽지 않을까?
        result = 0;
      }
      return result;
    },
  }
}
</script>

<style src="../../custom/amcharts/amchart_plugins.min.css"></style>
<style scoped>
.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 300px;
}

</style>



// WEBPACK FOOTER //
// src/views/modelCustom/ModelCustomModal.vue